window.mcb = window.mcb || {};
window.mcb.tracking = (function () {
  // Private variables
  const _logger = window.mcb.utilities.createLogger('tracking', 'Tracking System');

  // Internal functions
  const track = function (ruleName, obj) {
    if (typeof _satellite === "object" && typeof _satellite.track === "function") {
      if (ruleName.indexOf('Callable') !== 0) {
        ruleName = "Callable" + ruleName;
      }

      for (let prop in obj) {
        obj[prop] = window.mcb.utilities.browser.parseHtml(obj[prop]);
      }

      _satellite.track(ruleName, obj);
    }
    else {
      _logger.warn('"_satellite" is undefined - registration is not possible');
    }
  };

  // Public interface
  return {
    track
  };
})();
